import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';

import { MortgageCampaignSaroutycreditsimulatorViewStore } from 'common/module/mortgage/campaign/saroutycreditsimulator/view-store';
import { StatsService } from 'common/service/stats/service';

export function MortgageCampaignSaroutycreditsimulatorViewStoreFactory(): MortgageCampaignSaroutycreditsimulatorViewStore {
  return new MortgageCampaignSaroutycreditsimulatorViewStore(EventEmitterFactory(), StatsService());
}
